export default {
      id: "share-usage",
      viewBox: "0 0 18 21",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#share",
      toString: function () {
        return this.url;
      }
    }